require('../../modules/es6.number.is-nan');
module.exports = require('../../modules/_core').Number.isNaN;



// WEBPACK FOOTER //
// node_modules/_core-js@2.5.6@core-js/fn/number/is-nan.js